import React from 'react';

import { CurationDetails as CurationDetailsComponent } from '../../CurationDetails';

import { NotificationToast } from '../../../NotificationToast';
import { useCurationDetailsController } from './CurationDetails.controller';
import { CurationHero } from '../../components/CurationHero';
import { Page } from '../../components/LayoutStructure';
import { wrapWithCurationDetailsHealthProvider } from '@apps/registry/common/components/Catalog/routes/CurationDetails/CurationDetails.health';
import { Seo } from '@shared/components/Seo';

export interface CurationDetailsPageProps
  extends Readonly<{
    isMobile: boolean;
    curationLocator: string;
  }> {}

export const CurationDetails = wrapWithCurationDetailsHealthProvider((props: CurationDetailsPageProps) => {
  const {
    seoTrans,
    filters,
    handleOnLoadMoreProductsButtonClick,
    hasNextPage,
    isFetchingMore,
    notificationText,
    isLoadingSearchResults,
    notificationVisible,
    setNotificationVisible,
    selectedCuration,
    searchResults,
    shopProductConfirmationToastV2Enabled
  } = useCurationDetailsController(props);

  return (
    <Page marginBottom={'196px'} paddingTop={'0px'}>
      <Seo
        title={seoTrans.shopCurationDetailsTitle({ curation: selectedCuration?.curationData?.header?.title?.trim() || 'Curations' })}
        description={seoTrans.shopCurationDetailsDescription({ curation: selectedCuration?.curationData?.header?.title?.trim() || 'Curations' })}
      />
      {selectedCuration?.curationData?.header && (
        <CurationHero curationId={selectedCuration.id} hero={selectedCuration.curationData.header} videoUrl={selectedCuration.curationData.videoUrl} />
      )}
      <CurationDetailsComponent
        showSkeleton={!searchResults || isLoadingSearchResults}
        selectedCuration={selectedCuration}
        curationResults={searchResults}
        curationLocator={props.curationLocator}
        filters={filters}
        hasNextPage={hasNextPage}
        isFetchingMore={isFetchingMore}
        onLoadMoreClick={handleOnLoadMoreProductsButtonClick}
      />
      {!shopProductConfirmationToastV2Enabled && (
        <NotificationToast notificationText={notificationText} notificationVisible={notificationVisible} setNotificationVisible={setNotificationVisible} />
      )}
    </Page>
  );
});

CurationDetails.displayName = 'CurationDetails';
